import React, { Component } from 'react'
import { connect } from 'react-redux'

import { Row, Col } from 'react-bootstrap'
import { parseDate } from 'react-day-picker/moment'
import moment from 'moment'
import {
  faArrowRight,
  faBackspace,
  faIdCard,
  faUserPlus,
} from '@fortawesome/free-solid-svg-icons'

import {
  FormTextField,
  Select,
  CustomDate,
  CustomTabs,
  Geocoding,
  FormText,
  Button,
  Icon,
  Switch,
} from 'src/components'

import Gallery, { imageTypes } from 'src/components/gallery/Gallery'

import { actionTypes as typsC, getClientsSimple } from 'src/actions/clients.actions'
import { selectDeliverersToSelect, simpleClients } from 'src/selectors/clients.selector'

import { setInformationOrder } from 'src/actions/orders.actions'
import { selectGetSingleOrder } from 'src/selectors/orders.selector'

import { isAllowed } from 'src/selectors/modules.selector'

import { loadingSelector } from 'src/selectors/loading.selector'

import {
  getExistenceSingleWarehouseWithPriceProducts,
  getInventory,
} from 'src/actions/warehouse.actions'
import {
  selectCurrentCompany,
  selectCurrentModule,
  selectCurrentUser,
} from 'src/selectors/user.selector'

import {
  getContractedCompanies,
  getProductsByProducerContract,
} from 'src/actions/contracts.actions'
import { companies } from 'src/selectors/contracts.selector'

import { selectMethodPayment, selectModalOrder } from 'src/selectors/utilities.selector'

class OrderSelectClient extends Component {
  state = {
    minDate: parseDate(moment()),
    updateInventory: true,
    name: null,
    external: false,
    key: '0',
    global: false,
  }

  componentDidMount() {
    const { order, setInfo } = this.props
    console.log(order)
    const { linked } = this.props.match.params
    if (linked === 'true') this.setState({ external: true })
    if (!order.deliveryDate) order.deliveryDate = parseDate(moment())
    else order.deliveryDate = parseDate(order.deliveryDate)
    setInfo(order)
    this.props.getContractedCompanies()
  }

  onChangeClient = (data, parametter) => {
    const { order, setInfo } = this.props
    if (parametter === 'client') {
      let updateInventory = !(order[parametter] === data)
      this.setState({ updateInventory })
    }

    order[parametter] = data
    setInfo(order)
  }

  getInventory = () => {
    const { getInventoryWithPrices, order, currentCompany } = this.props
    if (order.warehouse && order.warehouse.value)
      getInventoryWithPrices(
        order.warehouse.value,
        order.client,
        currentCompany,
        true,
        false,
      )
  }

  changeClientName = event => {
    const { value } = event.target
    let { order } = this.props
    order['name'] = value
  }

  setKeyClient = key => {
    const { allClients } = this.props
    this.setState({ key })

    let newClient = allClients.find(c => c.code === '3000CA')
    if (newClient && key === '1') {
      const changeClient = Object.assign({}, newClient)
      changeClient['newClient'] = true
      this.onChangeClient(changeClient, 'client')
      this.setState({ name: '-' })
    }
  }

  onChangeInputNew = (value, param) => {
    const { order } = this.props
    let { client } = order
    if (client) {
      const changeClient = Object.assign({}, client)
      changeClient[param] = value
      this.onChangeClient(changeClient, 'client')
    }
  }

  renderPaymentType = className => {
    const { methodsPayment, order } = this.props
    const { external } = this.state
    return (
      <Col md={12} xl={12}>
        <div className={`column ${className}`}>
          <h6>
            <strong>Asignar metodo de pago</strong>
          </h6>
          <Row style={{ paddingBottom: 2, display: 'flex' }}>
            {methodsPayment
              .filter(m => m.link)
              .map((b, i) => (
                <Button
                  key={i}
                  onClick={() => this.onChangeClient(b, 'paymentType')}
                  style={{
                    flex: 1,
                    backgroundColor: order.paymentType
                      ? order.paymentType.value === b.value
                        ? 'rgb(73 197 86)'
                        : 'rgb(33 139 208)'
                      : 'rgb(33 139 208)',
                    border: '1px solid white',
                  }}
                >
                  {b.label}
                </Button>
              ))}
          </Row>
          <div className={'left'}>
            <span>
              <strong>
                {order.paymentType && order.paymentType.value
                  ? external
                    ? order.paymentType.extence
                    : order.paymentType.description
                  : 'Es necesario escoger un metodo de pago'}
              </strong>
            </span>
          </div>
        </div>
      </Col>
    )
  }

  render() {
    const {
      isRequiredClient,
      allClients,
      order,
      loading,
      loadingP,
      setInfo,
      currentCompany,
      contractedCompanies,
    } = this.props
    const { minDate, external, key } = this.state
    const { client, global } = order

    return (
      <div>
        <Row>
          <Col xl={5} lg={5} md={5} sm={12} xs={12}>
            <Row>
              {isRequiredClient && (
                <Col xl={12} lg={12} md={12} xs={12}>
                  <CustomTabs
                    setKey={key => this.setKeyClient(key)}
                    items={[
                      {
                        title: 'Escoger cliente',
                        info: 'Listado de clientes',
                        component: (
                          <Row>
                            {/*{currentCompany === 1 && <Col xl={12} lg={12} md={12} className={'mt-3'}>
                                                    <Switch
                                                        topLabel label={'Activar para visualizar empresas para la seleccion de cliente'} left
                                                        checked={global} onChange={({target}) => {
                                                            const {checked} = target;
                                                            setInfo({...order, global: checked});
                                                            const seeAll = this.props.getPermission([1057, 2156]);
                                                            this.props.getClients({
                                                                attendant: seeAll ? null : this.props.user.id,
                                                                kolo: checked
                                                            });
                                                        }}
                                                    />
                                                </Col>}*/}
                            <Col xl={12} lg={12} md={12} xm={12} xs={12}>
                              <Select
                                label={'Cliente'}
                                placeholder={'pj. Tienda Geovani'}
                                options={allClients}
                                value={client}
                                onChange={data => this.onChangeClient(data, 'client')}
                                loading={loading || loadingP}
                                required
                              />
                              <br />
                              {client &&
                                client.nit &&
                                (client.nit.toUpperCase() === 'CF' ||
                                  client.nit.toUpperCase() === 'C/F') &&
                                !client.code && (
                                  <div>
                                    <FormTextField
                                      label={'Nombre'}
                                      type={'text'}
                                      id={'name'}
                                      placeholder={'Consumidor Final'}
                                      name={'name'}
                                      value={this.props.order.name}
                                      onChange={this.changeClientName}
                                    />
                                  </div>
                                )}
                            </Col>
                          </Row>
                        ),
                      },
                      {
                        title: 'Cliente nuevo',
                        info: 'Crea un cliente nuevo para esta orden de venta',
                        component: (
                          <Row>
                            <Col xl={12} lg={12} md={12} sm={12}>
                              <FormText
                                prepend={<Icon icon={faUserPlus} tooltip={'Nombre'} />}
                                label={'Nombre del cliente'}
                                placeholder={'pj. cliente 12'}
                                value={client.label}
                                onChange={({ target }) => {
                                  this.onChangeInputNew(target.value, 'label')
                                  this.onChangeInputNew(target.value, 'companyName')
                                }}
                                required
                              />
                            </Col>
                            <Col xl={12} lg={12} md={12} sm={12}>
                              <FormText
                                prepend={<Icon icon={faIdCard} tooltip={'NIT'} />}
                                label={'NIT del cliente'}
                                placeholder={'pj. CF'}
                                value={client.nit}
                                onChange={({ target }) =>
                                  this.onChangeInputNew(target.value, 'nit')
                                }
                                required
                              />
                            </Col>
                          </Row>
                        ),
                      },
                    ]}
                  />
                </Col>
              )}
              {external && (
                <Col xs={12} sm={12} md={12} xl={12}>
                  <Select
                    label={'Compañía'}
                    value={order.delivererCompany}
                    options={contractedCompanies}
                    onChange={w => {
                      order.delivererCompany = w
                      this.props.getProductsByProducerContract(w.value)
                      setInfo(order)
                    }}
                    required
                  />
                </Col>
              )}
              <Col>
                <CustomDate
                  label={'Fecha de entrega'}
                  value={order.deliveryDate}
                  onDayChange={date => {
                    order.deliveryDate = date
                    setInfo(order)
                  }}
                  format={'LL'}
                  disabledDays={[{ before: minDate }]}
                  required
                />
              </Col>
              {this.renderPaymentType('payment-type-desktop')}
            </Row>
          </Col>
          <Col xl={7} lg={7} md={7} sm={12} xs={12}>
            {key === '0' ? (
              <div className={'custom-card'}>
                <Row style={{ justifyContent: 'center' }}>
                  <Gallery
                    company={currentCompany}
                    imageType={imageTypes.CLIENT}
                    entityId={client && client.id}
                    showUploader={false}
                    maxWidth={'400px'}
                    showDelete
                  />
                </Row>

                <Row style={{ justifyContent: 'center' }}>
                  <span className={'client-name'}>
                    {client.companyName || 'desconocido'}
                  </span>
                </Row>
                <hr />
                <Row className={'flex-container space-between'}>
                  <Col xs={3} className={'label'}>
                    Código
                  </Col>
                  <Col className={'description'}>{client.code || 'desconocido'}</Col>
                </Row>
                <Row className={'flex-container space-between'}>
                  <Col xs={3} className={'label'}>
                    Teléfono
                  </Col>
                  <Col className={'description'}>{client.phone || 'desconocido'}</Col>
                </Row>
                <Row className={'flex-container space-between'}>
                  <Col xs={3} className={'label'}>
                    Dirección
                  </Col>
                  <Col className={'description'}>{client.address || 'desconocido'}</Col>
                </Row>
                <Row className={'flex-container space-between'}>
                  <Col xs={3} className={'label'}>
                    Repartidor
                  </Col>
                  <Col className={'description'}>
                    {client.transporter || 'desconocido'}
                  </Col>
                </Row>
              </div>
            ) : (
              <Geocoding
                editable
                defaultAddress={client.address}
                auto
                getData={data => {
                  const { lat, lng } = data.latLng
                  this.onChangeInputNew(data.address, 'address')
                  this.onChangeInputNew(lat, 'latitude')
                  this.onChangeInputNew(lng, 'longitude')
                }}
              />
            )}
          </Col>
          {this.renderPaymentType('payment-type-mobile')}
        </Row>
        <hr />
        <Row className={'container-buttons'}>
          <Button
            color={'secondary'}
            onClick={() => window.history.back()}
            icon={faBackspace}
          >
            Salir
          </Button>
          <Button
            disabled={
              external
                ? !(
                    client.value &&
                    order.delivererCompany &&
                    order.paymentType &&
                    order.paymentType.value
                  )
                : !client.value || !(order.paymentType && order.paymentType.value)
            }
            icon={faArrowRight}
            right
            color={'primary'}
            onClick={() => {
              this.getInventory()
              this.props.jumpToStep(1)
            }}
          >
            Siguiente
          </Button>
        </Row>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  allClients: simpleClients(state),
  loading: loadingSelector([typsC.GET_ALL_CLIENTS])(state),
  loadingP: loadingSelector([typsC.GET_CLIENT_POLYGON])(state),
  order: selectGetSingleOrder(state),
  originalOrder: selectModalOrder(state),
  currentCompany: selectCurrentCompany(state),
  deliverers: selectDeliverersToSelect(state),
  module: selectCurrentModule(state),
  contractedCompanies: companies(state),
  methodsPayment: selectMethodPayment(state),
  getPermission: permissions => isAllowed(state, permissions),
  user: selectCurrentUser(state),
})
const mapDispatchToProps = dispatch => ({
  setInfo: order => dispatch(setInformationOrder(order)),
  getInventoryWithPrices: (id, client, currentCompany, includeNoExistence, reserve) =>
    dispatch(
      getExistenceSingleWarehouseWithPriceProducts(
        id,
        client,
        currentCompany,
        includeNoExistence,
        reserve,
        1,
      ),
    ),
  getInventory: (id, includeNoExistence) =>
    dispatch(getInventory(id, includeNoExistence, false)),
  getContractedCompanies: () => dispatch(getContractedCompanies(10)),
  getProductsByProducerContract: id => dispatch(getProductsByProducerContract(id)),
  getClients: params => dispatch(getClientsSimple(params)),
})

const ReduxComponent = connect(mapStateToProps, mapDispatchToProps)(OrderSelectClient)
export default ReduxComponent
